export const TALENT_VIDEO = {
  FISRT_MESSAGE: 'Please start with ',
  HTTPS_MSG: '"https://"',
  HTTP_MSG: '"http://"',
  HTTPS_EXAMPLE: 'https://www.example.com',
  HTTP_EXAMPLE: 'http://www.example.com',
};
